import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getAdminProjectPreview, adminProjectAction } from '../api/projects';
import { useAuth } from '../context/AuthContext';
import { getYouTubeEmbedUrl } from '../constants/categories';
import '../styles/ProjectDetail.css';
import '../styles/ICOListing.css';


import Navbar from '../components/Navbar';

const API_URL = 'https://onlineico.com/api';



export default function AdminProjectPreview() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { user } = useAuth();
    const [project, setProject]           = useState(null);
    const [loading, setLoading]           = useState(true);
    const [actionDone, setActionDone]     = useState('');
    const [showRejectForm, setShowRejectForm] = useState(false);
    const [rejectComment, setRejectComment]   = useState('');
    const [promos, setPromos]             = useState([]);

    const [openFaq, setOpenFaq] = useState(null);
    const [statusEdit, setStatusEdit]   = useState('');
    const [statusSaving, setStatusSaving] = useState(false);
    const [statusDone, setStatusDone]   = useState(false);

    useEffect(() => {
        if (!user || user.role !== 'admin') { navigate('/'); return; }
        loadProject();
    }, [id]);

    const loadProject = () => {
        getAdminProjectPreview(id).then(data => {
            setProject(data);
            setStatusEdit(data.status || 'live');
            setLoading(false);
            loadPromos(data.id);
        });
    };

    const loadPromos = async (projectId) => {
        const token = localStorage.getItem('onlineico_token');
        const r = await fetch(`${API_URL}/admin/boosts.php?status=all`, {
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
        });
        const boosts = await r.json();
        if (Array.isArray(boosts)) {
            setPromos(boosts.filter(b => parseInt(b.project_id) === parseInt(projectId)));
        }
    };

    const handleAction = async (action) => {
        await adminProjectAction(action, parseInt(id));
        setActionDone(action);
        loadProject();
    };

    if (loading) return <div className="app-wrap"><div style={{ padding: '4rem', textAlign: 'center', color: '#94a3b8' }}>Loading...</div></div>;
    if (!project) return <div className="app-wrap"><div style={{ padding: '4rem', textAlign: 'center', color: '#94a3b8' }}>Project not found.</div></div>;

    const colors = ['#34D399', '#8B5CF6', '#F59E0B', '#3B82F6', '#EC4899', '#10B981'];
    const color = colors[project.id % colors.length];
    const tokenomics = project.tokenomics ? JSON.parse(project.tokenomics) : null;
    const roadmap    = project.roadmap ? JSON.parse(project.roadmap) : null;
    const team       = project.team ? JSON.parse(project.team) : null;
    const tokenDist  = project.token_distribution ? JSON.parse(project.token_distribution) : null;
    const faq        = project.faq ? JSON.parse(project.faq) : null;

    return (
        <div className="app-wrap">
            <Navbar />
           

            {/* BARRE D'ACTION ADMIN */}
            <div style={{ background: 'rgba(10,15,30,0.9)', borderBottom: '1px solid rgba(255,255,255,0.07)', padding: '12px 2rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: parseInt(project.is_approved) === 1 ? '#34D399' : '#f87171', boxShadow: `0 0 5px ${parseInt(project.is_approved) === 1 ? '#34D399' : '#f87171'}` }} />
                    <span style={{ color: '#94a3b8', fontSize: '0.85rem' }}>
                        {parseInt(project.is_approved) === 1 ? 'En ligne' : 'En attente de validation'}
                    </span>
                    {project.owner && (
                        <span style={{ color: '#64748b', fontSize: '0.82rem' }}>· Soumis par <span style={{ color: '#94a3b8' }}>{project.owner}</span> ({project.owner_email})</span>
                    )}
                </div>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                    {parseInt(project.is_approved) === 0 && parseInt(project.email_verified) === 1 && (
                        <button onClick={() => handleAction('approve')}
                            style={{ background: 'rgba(52,211,153,0.1)', border: '1px solid rgba(52,211,153,0.3)', borderRadius: '8px', color: '#34D399', cursor: 'pointer', fontSize: '0.85rem', padding: '8px 16px', transition: 'all 0.2s' }}
                            onMouseEnter={e => e.currentTarget.style.background = 'rgba(52,211,153,0.2)'}
                            onMouseLeave={e => e.currentTarget.style.background = 'rgba(52,211,153,0.1)'}>
                            ✓ Valider le projet
                        </button>
                    )}
                    {parseInt(project.is_approved) === 0 && parseInt(project.email_verified) === 1 && (
                        <button onClick={() => setShowRejectForm(true)}
                            style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '8px', color: '#f87171', cursor: 'pointer', fontSize: '0.85rem', padding: '8px 16px', transition: 'all 0.2s' }}
                            onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.2)'}
                            onMouseLeave={e => e.currentTarget.style.background = 'rgba(239,68,68,0.1)'}>
                            ✕ Refuser
                        </button>
                    )}
                    {parseInt(project.is_approved) === 1 && (
                        <button onClick={() => handleAction('reject')}
                            style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '8px', color: '#f87171', cursor: 'pointer', fontSize: '0.85rem', padding: '8px 16px', transition: 'all 0.2s' }}
                            onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.2)'}
                            onMouseLeave={e => e.currentTarget.style.background = 'rgba(239,68,68,0.1)'}>
                            ⊘ Désactiver
                        </button>
                    )}
                    <button onClick={() => navigate('/admin')}
                        style={{ background: 'none', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: '#94a3b8', cursor: 'pointer', fontSize: '0.85rem', padding: '8px 16px' }}>
                        ← Retour
                    </button>
                </div>
            </div>

            {/* FORMULAIRE REFUS */}
            {showRejectForm && (
                <div style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)', padding: '16px 2rem', display: 'flex', gap: '12px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                    <div style={{ flex: 1, minWidth: '300px' }}>
                        <label style={{ color: '#f87171', fontSize: '0.82rem', marginBottom: '8px', display: 'block' }}>Motif du refus (sera envoyé par email au client)</label>
                        <textarea className="form-textarea" placeholder="Expliquez pourquoi la mise à jour est refusée..." value={rejectComment} onChange={e => setRejectComment(e.target.value)} rows={3} style={{ width: '100%' }} />
                    </div>
                    <div style={{ display: 'flex', gap: '8px', marginTop: '24px' }}>
                        <button
                            onClick={async () => {
                                if (!rejectComment.trim()) { alert('Le motif est obligatoire'); return; }
                                await adminProjectAction('reject', parseInt(id), rejectComment);
                                setShowRejectForm(false);
                                setRejectComment('');
                                setActionDone('reject');
                                loadProject();
                            }}
                            style={{ background: 'rgba(239,68,68,0.2)', border: '1px solid rgba(239,68,68,0.4)', borderRadius: '8px', color: '#f87171', cursor: 'pointer', fontSize: '0.85rem', padding: '8px 16px' }}>
                            Confirmer le refus
                        </button>
                        <button onClick={() => { setShowRejectForm(false); setRejectComment(''); }}
                            style={{ background: 'none', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: '#94a3b8', cursor: 'pointer', fontSize: '0.85rem', padding: '8px 16px' }}>
                            Annuler
                        </button>
                    </div>
                </div>
            )}

            {/* NOTIFICATION ACTION */}
            {actionDone && (
                <div style={{ background: actionDone === 'approve' ? 'rgba(52,211,153,0.1)' : 'rgba(239,68,68,0.1)', border: `1px solid ${actionDone === 'approve' ? 'rgba(52,211,153,0.3)' : 'rgba(239,68,68,0.3)'}`, padding: '10px 2rem', textAlign: 'center', color: actionDone === 'approve' ? '#34D399' : '#f87171', fontSize: '0.85rem' }}>
                    {actionDone === 'approve' ? '✓ Project approved and published!' : '✕ Project rejected. Email sent to the client.'}
                </div>
            )}

            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '1.5rem 1.5rem 0' }}>
                <button className="back-btn" onClick={() => navigate('/admin/projets')}>← Retour</button>
            </div>

            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1.5rem 4rem', display: 'grid', gridTemplateColumns: '1fr 300px', gap: '28px', alignItems: 'start' }}>

            {/* ══════════════ COLONNE PRINCIPALE ══════════════ */}
            <div>

                {/* HEADER */}
                <div className="detail-header">
                    <div className="detail-header-top">
                        <div className="logo-wrap" style={{ background: project.logo_url ? 'transparent' : colors[project.id % colors.length] }}>
                            {project.logo_url
                                ? <img src={project.logo_url} alt={project.name} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '20px' }} />
                                : project.name.substring(0, 2).toUpperCase()
                            }
                        </div>
                        <div>
                            <div className="detail-name">{project.name}</div>
                            <div className="detail-ticker">{project.ticker} · {project.chain} · {project.type?.toUpperCase()}</div>
                            <div className="detail-badges">
                                <span className={`status-badge status-${project.status}`}>{project.status}</span>
                                {project.categorie && (
                                    <span style={{ fontSize: '0.68rem', fontWeight: '700', padding: '3px 10px', borderRadius: '20px', background: 'rgba(139,92,246,0.12)', color: '#C4B5FD', border: '1px solid rgba(139,92,246,0.3)', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                        ✦ {project.categorie}
                                    </span>
                                )}
                                {project.kyc && <a href={project.kyc_url || '#'} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.68rem', fontWeight: '700', padding: '3px 10px', borderRadius: '20px', background: 'rgba(52,211,153,0.12)', color: '#34D399', border: '1px solid rgba(52,211,153,0.3)', display: 'inline-flex', alignItems: 'center', gap: '4px', textDecoration: 'none' }}>✅ KYC · {project.kyc}</a>}
                                {project.audit && <a href={project.audit_url || '#'} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.68rem', fontWeight: '700', padding: '3px 10px', borderRadius: '20px', background: 'rgba(139,92,246,0.12)', color: '#a78bfa', border: '1px solid rgba(139,92,246,0.3)', display: 'inline-flex', alignItems: 'center', gap: '4px', textDecoration: 'none' }}>🔒 Audit · {project.audit}</a>}
                            </div>
                        </div>
                    </div>
                    <div className="social-links">
                        {project.website   && <a href={project.website}    target="_blank" rel="noopener noreferrer" className="social-btn website">🌐 Site web</a>}
                        {project.twitter   && <a href={project.twitter}    target="_blank" rel="noopener noreferrer" className="social-btn twitter">𝕏 Twitter</a>}
                        {project.telegram  && <a href={project.telegram}   target="_blank" rel="noopener noreferrer" className="social-btn telegram">✈ Telegram</a>}
                        {project.discord   && <a href={project.discord}    target="_blank" rel="noopener noreferrer" className="social-btn" style={{ borderColor: 'rgba(139,92,246,0.3)', color: '#8B5CF6' }}>🎮 Discord</a>}
                        {project.whitepaper && <a href={project.whitepaper} target="_blank" rel="noopener noreferrer" className="social-btn whitepaper">📄 Whitepaper</a>}
                    </div>
                </div>

                {/* INFOS TECHNIQUES */}
                <div className="detail-section">
                    <div className="detail-section-title">🔧 Informations techniques</div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
                        {[
                            { label: 'Contract Address', val: project.contract_address },
                            { label: 'Date de lancement', val: project.launch_date },
                            { label: 'Presale start', val: project.presale_start },
                            { label: 'Fin presale', val: project.presale_end },
                            { label: 'Email contact', val: project.email },
                        ].filter(item => item.val).map((item, i) => (
                            <div key={i}>
                                <div style={{ color: '#64748b', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>{item.label}</div>
                                <div style={{ color: '#F1F5F9', fontSize: '0.85rem', wordBreak: 'break-all' }}>{item.val}</div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* COMMENTAIRE DE MODIFICATION */}
                {project.update_comment && (
                    <div className="detail-section">
                        <div className="detail-section-title">💬 Commentaire de modification</div>
                        <p className="detail-desc" style={{ WebkitLineClamp: 'unset', whiteSpace: 'pre-wrap' }}>{project.update_comment}</p>
                    </div>
                )}

                {/* DESCRIPTION */}
                <div className="detail-section">
                    <div className="detail-section-title">📝 Description</div>
                    {project.url_video && getYouTubeEmbedUrl(project.url_video) && (
                        <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', marginBottom: '20px', borderRadius: '16px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.07)' }}>
                            <iframe
                                src={getYouTubeEmbedUrl(project.url_video)}
                                title={`Vidéo ${project.name}`}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                            />
                        </div>
                    )}
                    <p className="detail-desc" style={{ WebkitLineClamp: 'unset' }}>{project.description}</p>
                </div>

                {/* TOKENOMICS */}
                {tokenomics && (
                    <div className="detail-section">
                        <div className="detail-section-title">📊 Tokenomics</div>
                        {/* Champs sans vesting */}
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '12px', marginBottom: '20px' }}>
                            {Object.entries(tokenomics).filter(([k]) => k !== 'phases' && k !== 'Vesting').map(([key, val]) => (
                                <div key={key} style={{ background: 'rgba(52,211,153,0.05)', border: '1px solid rgba(52,211,153,0.15)', borderRadius: '16px', padding: '16px', textAlign: 'center' }}>
                                    <div style={{ color: '#34D399', fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1.2rem', marginBottom: '4px' }}>{val}</div>
                                    <div style={{ color: '#94a3b8', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '1px' }}>{key}</div>
                                </div>
                            ))}
                        </div>
                        {tokenDist && (
                            <>
                                <div style={{ marginBottom: '12px', fontSize: '0.85rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px' }}>Distribution</div>
                                <div style={{ height: '36px', borderRadius: '12px', overflow: 'hidden', display: 'flex', marginBottom: '16px', border: '1px solid rgba(255,255,255,0.05)' }}>
                                    {tokenDist.map((item, i) => (
                                        <div key={i} style={{ width: `${item.percent}%`, background: item.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.72rem', fontWeight: '700', color: '#0B1120' }}>
                                            {item.percent}%
                                        </div>
                                    ))}
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))', gap: '6px', marginTop: '16px' }}>
                                    {tokenDist.map((item, i) => (
                                        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <div style={{ width: '10px', height: '10px', borderRadius: '2px', background: item.color, flexShrink: 0 }} />
                                            <span style={{ color: '#E2E8F0', fontSize: '0.82rem' }}>{item.label} <span style={{ color: item.color, fontWeight: '600' }}>{item.percent}%</span></span>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                        {tokenomics.phases && (
                            <div style={{ marginTop: '20px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '12px' }}>
                                    {tokenomics.phases.map((phase, i) => (
                                        <div key={i} style={{ textAlign: 'center', padding: '20px 12px', borderRadius: '16px', background: `rgba(74,222,128,${0.05 + i * 0.05})`, border: '1px solid rgba(74,222,128,0.2)', transition: 'all 0.3s ease' }}
                                            onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.03)'; e.currentTarget.style.boxShadow = '0 15px 30px -10px rgba(74,222,128,0.3)'; }}
                                            onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = 'none'; }}>
                                            <div style={{ marginBottom: '10px' }}>
                                                <span style={{ background: 'rgba(0,0,0,0.4)', color: '#F59E0B', padding: '4px 14px', borderRadius: '30px', fontSize: '0.82rem', fontWeight: '600', border: '1px solid rgba(255,255,255,0.1)' }}>
                                                    ✦ Phase {i + 1} ✦
                                                </span>
                                            </div>
                                            <div style={{ background: 'linear-gradient(135deg, #4ADE80, #22C55E)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1.3rem' }}>
                                                ${phase.price} <span style={{ color: '#94a3b8', fontSize: '0.8rem', WebkitTextFillColor: '#94a3b8' }}>USDT</span>
                                            </div>
                                            {phase.duration && <div style={{ color: '#94a3b8', fontSize: '0.75rem', marginTop: '6px' }}>{phase.duration}</div>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        {/* Vesting — affiché en dernier, séparé par virgules */}
                        {tokenomics['Vesting'] && (() => {
                            const vestingColors = ['#34D399', '#8B5CF6', '#F59E0B', '#3B82F6', '#EC4899', '#10B981'];
                            const items = tokenomics['Vesting'].split(',').map(s => s.trim()).filter(Boolean);
                            return (
                                <div style={{ marginTop: '20px' }}>
                                    <div style={{ marginBottom: '12px', marginTop: '24px', fontSize: '0.85rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px', textAlign: 'center' }}>Vesting Schedule</div>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '12px' }}>
                                        {items.map((item, i) => {
                                            const vc = vestingColors[i % vestingColors.length];
                                            return (
                                                <div key={i} style={{ background: `${vc}15`, border: `1px solid ${vc}40`, borderRadius: '16px', padding: '16px', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <div style={{ color: vc, fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '0.88rem', lineHeight: '1.5' }}>{item}</div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })()}
                    </div>
                )}

                {/* ROADMAP */}
                {roadmap && roadmap.length > 0 && (
                    <div className="detail-section">
                        <div className="detail-section-title">🗺️ Roadmap</div>
                        <div className="roadmap-list">
                            {roadmap.map((item, i) => (
                                <div className="roadmap-item" key={i}>
                                    <div className="roadmap-dot" style={{ background: i === 0 ? '#34D399' : i === 1 ? '#3B82F6' : i === 2 ? '#F59E0B' : '#8B5CF6' }} />
                                    <div className="roadmap-text">{item}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* EQUIPE */}
                {team && team.length > 0 && (
                    <div className="detail-section">
                        <div className="detail-section-title">👥 Équipe</div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                            {team.map((member, i) => {
                                const mc = ['#34D399', '#8B5CF6', '#F59E0B', '#3B82F6', '#EC4899'][i % 5];
                                return (
                                    <div key={i} style={{ background: 'rgba(20,30,50,0.5)', borderRadius: '20px', padding: '20px', textAlign: 'center', border: `1px solid ${mc}30` }}>
                                        <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: `linear-gradient(135deg, ${mc}, #0B1120)`, margin: '0 auto 12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '1rem', color: '#F1F5F9' }}>
                                            {member.name.substring(0, 2).toUpperCase()}
                                        </div>
                                        <div style={{ color: '#F1F5F9', fontWeight: '600', fontSize: '0.95rem', marginBottom: '4px' }}>{member.name}</div>
                                        <div style={{ color: mc, fontSize: '0.82rem', fontWeight: '600', marginBottom: '8px' }}>{member.role}</div>
                                        <div style={{ color: '#94a3b8', fontSize: '0.82rem', lineHeight: '1.5' }}>{member.bio}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}

                {/* FAQ */}

{faq && faq.length > 0 && (
    <div className="detail-section">
        <div className="detail-section-title">❓ FAQ</div>
        {faq.map((item, i) => (
            <div key={i} style={{ borderBottom: '1px solid rgba(255,255,255,0.07)', paddingBottom: '8px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', cursor: 'pointer', color: '#F1F5F9', fontSize: '0.95rem', fontWeight: '500' }}
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                    <span>{item.q}</span>
                    <span style={{ color: '#34D399', fontSize: '1.2rem', transition: 'transform 0.3s', transform: openFaq === i ? 'rotate(90deg)' : 'rotate(-90deg)' }}>➔</span>
                </div>
                {openFaq === i && (
                    <div style={{ padding: '12px 16px', background: 'rgba(255,255,255,0.03)', borderRadius: '12px', borderLeft: '3px solid #3B82F6', color: '#93c5fd', fontSize: '0.9rem', lineHeight: '1.7', marginBottom: '8px' }}>
                        {item.a}
                    </div>
                )}
            </div>
        ))}
    </div>
)}
            </div>{/* fin colonne principale */}

            {/* ══════════════ COLONNE DROITE — INFORMATION ══════════════ */}
            <div style={{ position: 'sticky', top: '80px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

                {/* PANNEAU INFORMATION */}
                <div style={{ background: 'rgba(10,15,30,0.6)', backdropFilter: 'blur(20px)', borderRadius: '24px', border: '1px solid rgba(255,255,255,0.07)', padding: '20px' }}>
                    <div style={{ color: '#F1F5F9', fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1rem', marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                        ℹ️ Information
                    </div>

                    {/* Email compte owner */}
                    {project.owner_email && (
                        <div style={{ marginBottom: '14px' }}>
                            <div style={{ color: '#64748b', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Compte propriétaire</div>
                            <div style={{ color: '#F1F5F9', fontSize: '0.82rem', wordBreak: 'break-all' }}>{project.owner_email}</div>
                            {project.owner && <div style={{ color: '#94a3b8', fontSize: '0.78rem', marginTop: '2px' }}>@{project.owner}</div>}
                        </div>
                    )}

                    {/* Email contact projet (si différent ou pas de compte) */}
                    {project.email && project.email !== project.owner_email && (
                        <div style={{ marginBottom: '14px' }}>
                            <div style={{ color: '#64748b', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Email contact projet</div>
                            <div style={{ color: '#F1F5F9', fontSize: '0.82rem', wordBreak: 'break-all' }}>{project.email}</div>
                        </div>
                    )}

                    {/* Soumission anonyme */}
                    {!project.owner_email && project.email && (
                        <div style={{ marginBottom: '14px' }}>
                            <div style={{ color: '#64748b', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Email (soumission anonyme)</div>
                            <div style={{ color: '#F1F5F9', fontSize: '0.82rem', wordBreak: 'break-all' }}>{project.email}</div>
                        </div>
                    )}

                    {/* Date de création */}
                    {project.created_at && (
                        <div style={{ marginBottom: '14px' }}>
                            <div style={{ color: '#64748b', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Fiche créée le</div>
                            <div style={{ color: '#F1F5F9', fontSize: '0.82rem' }}>
                                {new Date(project.created_at).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })}
                            </div>
                            <div style={{ color: '#64748b', fontSize: '0.75rem', marginTop: '2px' }}>
                                {new Date(project.created_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                            </div>
                        </div>
                    )}

                    {/* Séparateur */}
                    <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', margin: '14px 0' }} />

                    {/* Alertes Cron */}
                    <div>
                        <div style={{ color: '#64748b', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px' }}>Historique alertes cron</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
                                <span style={{ color: '#94a3b8', fontSize: '0.8rem', flexShrink: 0 }}>Relance générale</span>
                                {project.last_relance_sent
                                    ? <span style={{ color: '#34D399', fontSize: '0.75rem', textAlign: 'right' }}>
                                        📧 {new Date(project.last_relance_sent).toLocaleDateString('fr-FR')}
                                      </span>
                                    : <span style={{ color: '#475569', fontSize: '0.75rem', background: 'rgba(71,85,105,0.15)', padding: '2px 8px', borderRadius: '20px' }}>
                                        Jamais
                                      </span>
                                }
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
                                <span style={{ color: '#94a3b8', fontSize: '0.8rem', flexShrink: 0 }}>KYC &amp; Audit</span>
                                {project.kyc_relance_sent
                                    ? <span style={{ color: '#34D399', fontSize: '0.75rem', textAlign: 'right' }}>
                                        📧 {new Date(project.kyc_relance_sent).toLocaleDateString('fr-FR')}
                                      </span>
                                    : ((!project.kyc || parseInt(project.kyc) === 0) && (!project.audit || parseInt(project.audit) === 0))
                                        ? <span style={{ color: '#8B5CF6', fontSize: '0.75rem', background: 'rgba(139,92,246,0.1)', padding: '2px 8px', borderRadius: '20px', border: '1px solid rgba(139,92,246,0.25)' }}>
                                            En attente
                                          </span>
                                        : <span style={{ color: '#475569', fontSize: '0.75rem', background: 'rgba(71,85,105,0.15)', padding: '2px 8px', borderRadius: '20px' }}>
                                            N/A
                                          </span>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {/* OUTILS */}
                <div style={{ background: 'rgba(10,15,30,0.6)', backdropFilter: 'blur(20px)', borderRadius: '24px', border: '1px solid rgba(255,255,255,0.07)', padding: '20px' }}>
                    <div style={{ color: '#F1F5F9', fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1rem', marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                        🛠️ Outils
                    </div>

                    {/* Changement de statut */}
                    <div>
                        <div style={{ color: '#64748b', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Statut du projet</div>
                        <select
                            value={statusEdit}
                            onChange={e => { setStatusEdit(e.target.value); setStatusDone(false); }}
                            style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '10px', color: '#F1F5F9', fontSize: '0.85rem', padding: '8px 12px', marginBottom: '10px', cursor: 'pointer', outline: 'none', fontFamily: 'Inter, sans-serif' }}>
                            <option value="live" style={{ background: '#0B1120' }}>Live</option>
                            <option value="upcoming" style={{ background: '#0B1120' }}>Upcoming</option>
                            <option value="ended" style={{ background: '#0B1120' }}>Ended</option>
                        </select>
                        <button
                            disabled={statusSaving || statusEdit === project.status}
                            onClick={async () => {
                                setStatusSaving(true);
                                const token = localStorage.getItem('onlineico_token');
                                await fetch(`${API_URL}/admin/projects.php`, {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                                    body: JSON.stringify({ action: 'set_status', id: parseInt(id), note: statusEdit })
                                });
                                setStatusSaving(false);
                                setStatusDone(true);
                                loadProject();
                            }}
                            style={{ width: '100%', padding: '9px', borderRadius: '10px', border: '1px solid rgba(52,211,153,0.3)', background: statusEdit === project.status ? 'rgba(255,255,255,0.03)' : 'rgba(52,211,153,0.08)', color: statusEdit === project.status ? '#475569' : '#34D399', fontWeight: '600', fontSize: '0.85rem', cursor: statusEdit === project.status ? 'not-allowed' : 'pointer', transition: 'all 0.2s', fontFamily: 'Inter, sans-serif' }}
                            onMouseEnter={e => { if (statusEdit !== project.status) e.currentTarget.style.background = 'rgba(52,211,153,0.15)'; }}
                            onMouseLeave={e => { if (statusEdit !== project.status) e.currentTarget.style.background = 'rgba(52,211,153,0.08)'; }}>
                            {statusSaving ? '⏳ Enregistrement...' : statusDone ? '✓ Statut mis à jour' : 'Valider'}
                        </button>
                    </div>
                </div>

                {/* OFFRES PUBLICITAIRES */}
                {promos.length > 0 && (
                    <div style={{ background: 'rgba(10,15,30,0.6)', backdropFilter: 'blur(20px)', borderRadius: '24px', border: '1px solid rgba(255,255,255,0.07)', padding: '20px' }}>
                        <div style={{ color: '#F1F5F9', fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1rem', marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                            📢 Offres publicitaires
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {promos.map((promo, i) => {
                                const expired = promo.status === 'expired' || promo.status === 'rejected';
                                return (
                                <div key={i} style={{ padding: '12px', background: expired ? 'rgba(255,255,255,0.01)' : 'rgba(255,255,255,0.02)', borderRadius: '14px', border: `1px solid ${expired ? 'rgba(255,255,255,0.03)' : 'rgba(255,255,255,0.06)'}`, opacity: expired ? 0.5 : 1 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                        <span style={{ color: expired ? '#475569' : '#F59E0B', fontWeight: '700', fontSize: '0.82rem', textTransform: 'capitalize' }}>{promo.promo_type}</span>
                                        <span style={{ color: promo.status === 'confirmed' ? '#34D399' : promo.status === 'rejected' ? '#f87171' : promo.status === 'expired' ? '#475569' : '#F59E0B', fontSize: '0.75rem', fontWeight: '600' }}>
                                            {promo.status === 'confirmed' ? '✅ Actif' : promo.status === 'rejected' ? '✕ Refusé' : promo.status === 'expired' ? '⊘ Expiré' : '⏳ En attente'}
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.78rem' }}>
                                        <span style={{ color: expired ? '#475569' : '#94a3b8' }}>{promo.setting_label || promo.pack}</span>
                                        <span style={{ color: expired ? '#475569' : '#34D399', fontWeight: '600' }}>{promo.amount} $</span>
                                    </div>
                                    {promo.promo_until && (
                                        <div style={{ marginTop: '6px', color: '#475569', fontSize: '0.72rem' }}>
                                            {expired ? 'Expiré le ' : 'Expire le '}{new Date(promo.promo_until).toLocaleDateString('fr-FR')}
                                        </div>
                                    )}
                                </div>
                                );
                            })}
                        </div>
                    </div>
                )}

            </div>{/* fin colonne droite */}

            </div>{/* fin grid */}
        </div>
    );
}